"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "spezzano-della-sila": {
    "a4e35b42": [{
      "hkey": "da99ce51",
      "slug": "colle-lungo",
      "name": "Colle Lungo",
      "primary": true,
      "skipSearch": false
    }],
    "collelungo": [{
      "hkey": "da99ce51",
      "slug": "colle-lungo",
      "name": "Colle Lungo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "989a9476": [{
      "hkey": "e799c2d1",
      "slug": "spezzano-della-sila",
      "name": "Spezzano della Sila",
      "primary": true,
      "skipSearch": false
    }],
    "guzzolini": [{
      "hkey": "e799c2d1",
      "slug": "spezzano-della-sila",
      "name": "Spezzano della Sila",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "27ff5f86": [{
      "hkey": "e799c2d1",
      "slug": "spezzano-della-sila",
      "name": "Spezzano della Sila",
      "primary": true,
      "skipSearch": false
    }],
    "molarotta": [{
      "hkey": "e799c2d1",
      "slug": "spezzano-della-sila",
      "name": "Spezzano della Sila",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;